import { IErrorBagState } from './types';
import { RootState } from '../index';

export function errorBagSelector(state: RootState): IErrorBagState {
  return state.error.errorBag;
}
